'use strict';

import React from 'react';
import TextInput from 'components/base/form-components/TextInput';

import classNames from 'classnames';

import 'styles/TextInputWithSign.scss';


class TextInputWithSign extends React.Component {

    getValue() {
        const ref = this.props.name;
        return this.refs[ref].getValue();
    }

    setValue(value) {
        const ref = this.props.name;
        return this.refs[ref].setValue(value);
    }

    render() {
        var signClass = classNames({
            prepend: this.props.prepend,
            append: this.props.append,
        });

        return (
            <div className="text-input-with-sign">
                <TextInput
                    ref={this.props.name}
                    signClass={signClass}
                    {...this.props}
                />
            </div>
        );
    }
}

export default TextInputWithSign;

